import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import { FaPaperclip } from "react-icons/fa";
import CloseIcon from "@mui/icons-material/Close";

export default function DialogQuestionarAprovacao({
  aberto,
  motivo,
  onChangeMotivo,
  idsUsuarioResposta,
  onChangeUsuariosResposta,
  usuariosAtivos,
  idUsuarioAtual,
  onCancelar,
  onConfirmar,
  processando,
  titulo,
  contentText,
  labelCampo = "Questão / dúvida",
  rows = 3,
  maxLength, // mantido por compatibilidade: o texto agora é livre
  labelSelect = "Quem deve responder",
  labelConfirmar = "Questionar",
  corConfirmar = "#f57c00",
  arquivo,
  onChangeArquivo,
}) {
  const [selectAberto, setSelectAberto] = useState(false);
  // O questionador não pode se designar como respondente da própria pergunta.
  const usuariosSelecionaveis = usuariosAtivos.filter((u) => u.id !== idUsuarioAtual);
  return (
    <Dialog open={aberto} onClose={onCancelar} maxWidth="md" fullWidth>
      <DialogTitle sx={{ backgroundColor: "var(--ig-f-1e1e1e)", color: "var(--ig-t-ffffff)" }}>{titulo}</DialogTitle>
      <DialogContent sx={{ backgroundColor: "var(--ig-f-1e1e1e)", pt: "20px !important", overflowX: "hidden" }}>
        {contentText && <DialogContentText sx={{ color: "var(--ig-t-aaaaaa)", mb: 2 }}>{contentText}</DialogContentText>}
        <TextField
          autoFocus
          fullWidth
          multiline
          // Texto livre: campo maior, que cresce conforme a digitação.
          minRows={Math.max(rows, 8)}
          maxRows={20}
          label={labelCampo}
          value={motivo}
          onChange={(e) => onChangeMotivo(e.target.value)}
          helperText={`${motivo.length} caracteres`}
          slotProps={{
            htmlInput: { style: { color: "var(--ig-t-ffffff)" } },
            inputLabel: { sx: { color: "var(--ig-t-888888)", "&.Mui-focused": { color: "var(--ig-t-64b5f6)" } } },
          }}
          sx={{
            mb: 2,
            "& .MuiOutlinedInput-root": { "& fieldset": { borderColor: "var(--ig-b-444444)" } },
            "& .MuiFormHelperText-root": { color: "var(--ig-t-888888)" },
          }}
        />
        <FormControl fullWidth>
          <InputLabel sx={{ color: "var(--ig-t-888888)", "&.Mui-focused": { color: "var(--ig-t-64b5f6)" } }}>{labelSelect}</InputLabel>
          <Select
            multiple
            value={idsUsuarioResposta}
            open={selectAberto}
            onOpen={() => setSelectAberto(true)}
            onClose={() => setSelectAberto(false)}
            onChange={(e) => onChangeUsuariosResposta(typeof e.target.value === "string" ? e.target.value.split(",") : e.target.value)}
            label={labelSelect}
            renderValue={(selected) =>
              usuariosSelecionaveis
                .filter((u) => selected.includes(u.id))
                .map((u) => u.nome)
                .join(", ")
            }
            sx={{ color: "var(--ig-t-ffffff)", "& .MuiOutlinedInput-notchedOutline": { borderColor: "var(--ig-b-444444)" } }}
          >
            {usuariosSelecionaveis.map((u) => (
              <MenuItem key={u.id} value={u.id}>
                <Checkbox checked={idsUsuarioResposta.includes(u.id)} />
                <ListItemText primary={u.nome} />
              </MenuItem>
            ))}
            <Box sx={{ p: 1, borderTop: "1px solid var(--ig-b-444444)" }}>
              <Button
                fullWidth
                size="small"
                variant="contained"
                onClick={() => setSelectAberto(false)}
                sx={{ backgroundColor: "#1998a8", textTransform: "none", "&:hover": { backgroundColor: "#1565c0" } }}
              >
                Selecionar
              </Button>
            </Box>
          </Select>
        </FormControl>
        {onChangeArquivo && (
          <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1 }}>
            <Button
              component="label"
              variant="contained"
              startIcon={<FaPaperclip />}
              size="small"
              sx={{ width: "auto", backgroundColor: "#007bff", fontWeight: 700, "&:hover": { backgroundColor: "#0069d9" }, textTransform: "none" }}
            >
              GED
              <input type="file" hidden onChange={(e) => onChangeArquivo(e.target.files?.[0] ?? null)} />
            </Button>
            {arquivo && (
              <>
                <Typography sx={{ color: "var(--ig-t-cccccc)", fontSize: "0.82rem" }}>{arquivo.name}</Typography>
                <IconButton size="small" onClick={() => onChangeArquivo(null)} sx={{ color: "var(--ig-t-888888)" }}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </>
            )}
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ backgroundColor: "var(--ig-f-1e1e1e)", pb: 2, pr: 2 }}>
        <Button onClick={onCancelar} sx={{ color: "var(--ig-t-888888)" }}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={onConfirmar}
          disabled={!motivo.trim() || idsUsuarioResposta.length === 0 || processando}
          sx={{ backgroundColor: corConfirmar, textTransform: "none" }}
        >
          {labelConfirmar}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
